import SampleText from "./SampleText"

export default SampleText